import { render, staticRenderFns } from "./PurchasingRequestEditModal.vue?vue&type=template&id=2998a178"
import script from "./PurchasingRequestEditModal.vue?vue&type=script&lang=js"
export * from "./PurchasingRequestEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports